import { UseMutationResult, useMutation, useQueryClient } from "react-query";
import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { IPackagingRule } from "./useGetPackagingRules";

export interface ICreatePackagingRuleParameters {
    variantId: string;
    productId: string;
    maxUnits: number;
    material: number;
    units: number;
}

export const useCreatePackagingRule = (
    invalidQueryKeys: string | string[]
): UseMutationResult<IPackagingRule, unknown, ICreatePackagingRuleParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IPackagingRule, unknown, ICreatePackagingRuleParameters>({
        mutationFn: async (parameters: ICreatePackagingRuleParameters) => {
            if (!auth.token) {
                throw new Error("Cannot create packaging rule without authorization token.");
            }

            return await api.Products.createPackagingRule({
                ...parameters,
                token: auth.token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};